<template>
  <ui-card name="user.timeline" rounded :error="error">
    <div slot="controls">
      <timeline-datepicker/>
    </div>
    <timeline-current v-if="hasCurrent"/>
    <timeline-items/>
  </ui-card>
</template>

<script>
import TimelineDatepicker from "../timeline/TimelineDatepicker";
import TimelineCurrent from "../timeline/TimelineCurrent";
import TimelineItems from "../timeline/TimelineItems";
import { some } from "lodash";
import { mapState } from "vuex";

export default {
  name: "UserTimeline",
  components: {
    TimelineDatepicker,
    TimelineCurrent,
    TimelineItems
  },
  computed: {
    ...mapState("user", ["event_history"]),

    hasCurrent() {
      const hasCurrent = some(this.event_history, item => item.end_ts === null);

      return hasCurrent;
    },

    error() {
      if (!this.event_history || this.event_history.length === 0) {
        return "no_timeline";
      }

      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.user-timeline {
  height: calc(100vh - 120px);
}
</style>

<style lang="scss">
.user-timeline {
  .card-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
}
</style>
